import { useEffect, useRef } from 'react'

import { useJivo } from 'app/common/ui-components/jivo/useJivo'

type Props = {
  name: string
  phone: string
  email: string
  role: string
  os: string
  jivoCode: string | null
  themeColor?: string
  ready?: boolean
}

export const JivoWidget = (props: Props) => {
  const { jivoCode, name, email, phone, role, os, themeColor, ready } = props
  const hasJivoScript = useRef(false)

  if (jivoCode && !hasJivoScript.current) {
    hasJivoScript.current = true
    const script = document.createElement('script')
    script.src = `//code.jivo.ru/widget/${jivoCode}`
    document.head.append(script)
  }

  const { widgetLoaded, setContactInfo, setCustomData } = useJivo({ themeColor })

  useEffect(() => {
    if (widgetLoaded && ready) {
      setContactInfo({
        name,
        email,
        phone,
      })

      setCustomData([
        {
          title: 'Роль',
          content: role,
        },
        {
          title: 'Фамилия Имя',
          content: name,
        },
        {
          title: 'Почта',
          content: email,
        },
        {
          title: 'Телефон',
          content: phone,
        },
        {
          title: 'Операционная система',
          content: os,
        },
      ])
    }
  }, [widgetLoaded, ready, name, email, phone, role, os, setContactInfo, setCustomData])

  return null
}
